// List Group — collapsible group headers
// Toggles .is-collapsed on header and .is-hidden on next .list-group-collapsible sibling
(function() {
  document.addEventListener('click', function(e) {
    var header = e.target.closest('[data-list-group-toggle]');
    if (!header) return;
    var content = header.nextElementSibling;
    if (!content || !content.classList.contains('list-group-collapsible')) return;
    header.classList.toggle('is-collapsed');
    content.classList.toggle('is-hidden');
  });
})();
